import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { HerausgebersService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [HerausgebersService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class HerausgebersServiceModule {}
